module.exports = __webpack_public_path__ + "img/logo_white.690b3b92.png";